import React, { FC } from 'react';
import { t } from '../../../utils/helpers';
import CheckboxSwitch from '@ui-kit/components/checkboxSwitch';

type PropsType = {
  doNotDisturb: boolean;
  disturbHandle: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

export const InvitesDoNotDisturbSwitcher: FC<PropsType> = ({
  doNotDisturb,
  disturbHandle,
}: PropsType) => {
  return (
    <CheckboxSwitch
      id="gcDisallowChatWhilePlaying"
      name="InvitesDoNotDisturbSwitcher"
      checked={doNotDisturb}
      handler={disturbHandle}
    >
      {t('dont_disturb')}
    </CheckboxSwitch>
  );
};
